import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom"
import 'react-modal-video/scss/modal-video.scss';

const styles = {
    mainCheckBoxList: {
        textAlign: "left",
        display: "flex",
        justifyContent: "center",
        marginTop: "30px"
    },
}

const GpsMainSite = () => {
    const history = useHistory()
    const [pageData, setPageData] = useState()

    useEffect(() => {
        //getPageData()
        document.title = "MT";
    }, [])

    return (
        <React.Fragment>
            <main id="content" role="main">
                <div className="gradient-x-overlay-sm-primary11 position-relative overflow-hidden" style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div className="container">
                        <div className="w-lg-65 text-center mx-lg-auto">
                            <h1 className="display-6 mb-8">
                                {pageData?.serverPrivateIp}
                            </h1>
                        </div>
                    </div>
                </div>
            </main>
        </React.Fragment>
    )
}

export default GpsMainSite;
